import { ClipboardModule } from '@angular/cdk/clipboard';
import { NgModule } from '@angular/core';
import { LockedTooltipModule, OperadorasSelectModule, WebchatModule } from '@gestor-web/app/shared/components';
import { AppSharedModule, PrimengModule } from '@gestor-web/app/shared/modules';
import { Popover } from 'primeng/popover';
import { AppMainComponent } from './app.main.component';
import { AvisoInatividadeComponent } from './aviso-inatividade/aviso-inatividade.component';
import { AppBreadcrumbComponent } from './breadcrumb/app.breadcrumb.component';
import { AppFooterComponent } from './footer/app.footer.component';
import { AppInlineMenuComponent } from './inline-menu/app.inlinemenu.component';
import { AppMenuComponent } from './menu/app.menu.component';
import { MenuService } from './menu/app.menu.service';
import { AppMenuitemComponent } from './menu/app.menuitem.component';
import { NotificacaoDialogComponent } from './notificacao-dialog/notificacao-dialog.component';
import { PesquisaNpsDialogComponent } from './pesquisa-nps-dialog/pesquisa-nps-dialog.component';
import { PoliticaPrivacidadeComponent } from './politica-privacidade/politica-privacidade.component';
import { AppTopBarComponent } from './topbar/app.topbar.component';

@NgModule({
  imports: [
    AppSharedModule,
    PrimengModule,
    ClipboardModule,
    OperadorasSelectModule,
    WebchatModule,
    Popover,
    LockedTooltipModule,
  ],
  declarations: [
    AppMainComponent,
    AppMenuComponent,
    AppMenuitemComponent,
    AppBreadcrumbComponent,
    AppTopBarComponent,
    AppFooterComponent,
    AppInlineMenuComponent,
    AvisoInatividadeComponent,
    NotificacaoDialogComponent,
    PesquisaNpsDialogComponent,
    PoliticaPrivacidadeComponent,
  ],
  exports: [PesquisaNpsDialogComponent],
  providers: [MenuService],
})
export class LayoutModule {}
